import { render, staticRenderFns } from "./ParentView.vue?vue&type=template&id=60ba578e"
import script from "./ParentView.vue?vue&type=script&lang=ts"
export * from "./ParentView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports